import { forwardRef } from 'react';
import { Alert } from '../../alert/index.js';
import { Input, Label, Required } from '../formstyles.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { ALERT_VARIANTS } from '../../alert/constants.js';

const InputField = /*#__PURE__*/forwardRef(function InputField(_ref, ref) {
  let {
    error,
    hideRequired = false,
    hideLabel = false,
    label,
    required = false,
    ...rest
  } = _ref;
  return hideLabel ? /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Input, {
      "aria-label": label,
      ref: ref,
      required: required,
      hasError: error,
      ...rest
    }), error && /*#__PURE__*/jsx(Alert, {
      variant: ALERT_VARIANTS.ERROR,
      children: error
    })]
  }) : /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Label, {
      children: [/*#__PURE__*/jsx(Required, {
        required: required,
        hideRequired: hideRequired,
        children: label
      }), /*#__PURE__*/jsx(Input, {
        ref: ref,
        required: required,
        hasError: error,
        ...rest
      })]
    }), error && /*#__PURE__*/jsx(Alert, {
      variant: ALERT_VARIANTS.ERROR,
      children: error
    })]
  });
});

export { InputField };
